// file imports
import { ProfileField, ProfilePhotoUpload, ProfileToggle } from '@/components';
import { IUser } from '@/types';

interface ProfileMainCardProps {
  user: IUser;
  onFieldSave: (field: keyof IUser, value: string) => void;
  onToggleSave?: (field: keyof IUser, value: any) => void;
  onPhotoUpdate?: (url: string) => void;
}

export default function ProfileMainCard({ user, onFieldSave, onToggleSave, onPhotoUpdate }: ProfileMainCardProps) {
  const speakingCategoryOptions = [
    { value: 'Money', label: 'Money' },
    { value: 'AI', label: 'AI' },
    { value: 'Leadership', label: 'Leadership' },
  ];

  return (
    <div className="bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-10 shadow flex flex-col gap-4 sm:gap-6 md:gap-8 max-w-5xl mx-auto mb-6 sm:mb-8">
      <div className="flex flex-col md:flex-row md:items-center gap-4 sm:gap-6 md:gap-8">
        {/* ProfilePhoto */}
        <ProfilePhotoUpload currentPhoto={user.profilePhoto} onPhotoUpdate={onPhotoUpdate || ((url) => onFieldSave('profilePhoto', url))} />

        {/* Info grid */}
        <div className="flex-1">
          <div className="flex flex-col gap-4 sm:gap-6 md:gap-8">
            <ProfileField label="First Name" value={user.firstName || ''} onSave={(v) => onFieldSave('firstName', v)} type="text" />
            <ProfileField label="Last Name" value={user.lastName || ''} onSave={(v) => onFieldSave('lastName', v)} type="text" />
            <ProfileField label="Email" value={user.email || ''} onSave={(v) => onFieldSave('email', v)} type="email" />
            <ProfileField label="Password" value={'********'} onSave={(v) => onFieldSave('password' as keyof IUser, v)} type="password" disabled={Boolean(user.provider && user.provider !== 'email')} customDisplay={() => (user.provider && user.provider !== 'email' ? `You're currently logged in with ${user.provider.toUpperCase()}` : '********')} />
            <ProfileField label="Phone" value={user.phone || ''} onSave={(v) => onFieldSave('phone', v)} type="tel" />
            <ProfileField label="Speaking Category" value={user.speakingCategory || 'leadership'} onSave={(v) => onFieldSave('speakingCategory', v)} type="select" options={speakingCategoryOptions} />
            <ProfileField label="TBOS Handle" value={user?.slug || ''} onSave={(v) => onFieldSave('slug', v)} type="text" customDisplay={(value) => `tbos.ac/${value}`} />
            <ProfileToggle
              label="Send Thank You Emails"
              tooltip="Send thank you emails with your contact details to attendees who complete feedback"
              value={user.emailNotifications?.sendThankYouEmails ?? true}
              onToggle={(value) => {
                if (onToggleSave) {
                  const updatedEmailNotifications = { ...user.emailNotifications, sendThankYouEmails: value };
                  onToggleSave('emailNotifications' as keyof IUser, updatedEmailNotifications);
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
